import React from 'react';
import { LoanApplicationContext, LoanApplicationContextData } from 'src/providers';

export const useLoanApplication = (): LoanApplicationContextData => {
  return React.useContext<LoanApplicationContextData>(LoanApplicationContext);
};
